import { Navigate } from "react-router-dom";
import { hasAccess } from "../../utils/permissions";



const ProtectedRoute = ({ user, requiredLevel , children, isLoggedIn, onRequireLogin  }) => {
  if (!user || typeof user.subscriptionLevel !== 'number') {
    return <div>Loading...</div>;
  }
  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  if (typeof requiredLevel === 'number' && !hasAccess(user, requiredLevel))  { 
    return <Navigate to="/upgrade" replace />; 
   }
/*    console.log("🛡️ ProtectedRoute check", {
    user,
    isLoggedIn,
    requiredLevel,
    access: hasAccess(user, requiredLevel),
  }); */
  
  return children;
};

export default ProtectedRoute;
